<template>
  <div>
    <div id="particles-js"></div>
    <slot></slot>
  </div>
</template>

<script>
import web from './json/web.json'
import 'particles.js'

export default {
  name: 'Particles',

  methods: {
    initParticlesJS () {
      /* eslint-disable */
      particlesJS('particles-js', web)
    },
  },

  mounted () {
    setTimeout(this.initParticlesJS, 500)
  },
}
</script>
